import React from 'react'

import { getInitState, getToggledState } from './utils'

export const useInternalState = ({ skillsArray }) => {
  const [reviewsOpenState, setReviewsOpenState] = React.useState(
    getInitState(skillsArray),
  )

  const allReviewsOpen = Object.values(reviewsOpenState).every(open => open)

  const toggleAllReviews = () =>
    setReviewsOpenState(getToggledState(skillsArray, allReviewsOpen))

  const toggleReview = key => {
    setReviewsOpenState({ ...reviewsOpenState, [key]: !reviewsOpenState[key] })
  }

  return {
    state: {
      allReviewsOpen,
      reviewsOpenState,
    },
    handlers: {
      toggleAllReviews,
      toggleReview,
    },
  }
}
